<template id="modal">
  <div>
    <h1>404 yoo... not found</h1>
  </div>
</template>
<script>
  export default {
  
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue